export function useModalAcceptTerms() {
  const STORAGE_KEY = 'b2bTermsAccepted'

  const isModalVisible = ref(false)
  const hasUserChecked = ref(false)

  const acceptTerms = () => {
    localStorage.setItem(STORAGE_KEY, 'true')
    isModalVisible.value = false
  }

  const clearTermsAcceptance = () => {
    localStorage.removeItem(STORAGE_KEY)
  }

  onMounted(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      isModalVisible.value = true
    }
  })

  return {
    isModalVisible,
    hasUserChecked,
    acceptTerms,
    clearTermsAcceptance,
  }
}
